import moment from 'moment'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CustomPrimeTable from '../../../../../common/PrimeTable/CustomPrimeTable'
import useTablePaginationConfig from '../../../../../hooks/useTablePaginationConfig'
import { getProspects } from '../redux/dashboardOpportunityChartActions'
import Loader from '../../../../../modules/Loader/BasicLoader'

export default function ProspectsTable({ filters, stage }) {
  const { prospects, isLoading } = useSelector((state) => ({
    prospects: state.dashboardOpportunityChart.prospects,
    isLoading: state.dashboardOpportunityChart.isLoading,
  }))

  const { options, onFilterChange, onPageChange, onSortChange, setOptions, sortMeta } = useTablePaginationConfig({
    creationDate: 1,
  })

  const [isReady, setIsReady] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    setOptions((p) => ({ ...p, filter: filters }))
    setIsReady(true)
  }, [filters])

  useEffect(() => {
    if (isReady) {
      dispatch(getProspects(stage, options))
    }
  }, [options, stage, isReady])

  const stageBody = (rowData) => {
    return `${rowData.stageName}`
  }

  const contactNameBody = (rowData) => {
    return (
      <span className='btn-link' onClick={() => window.open(`/contacts/${rowData.contactData.id}`, '_blank')}>
        {rowData.contactData.name}
      </span>
    )
  }
  const columns = [
    { field: `stageName`, header: 'Stage', style: { textAlign: 'center', width: '20%' }, body: stageBody },
    { field: `contactName`, header: 'Contact', style: { textAlign: 'center' }, body: contactNameBody },
    // { field: `name`, header: 'Opportunity Name', style: { textAlign: 'center' } },
    // {
    //   field: 'typeName',
    //   header: 'Opt. Type',
    //   style: { textAlign: 'center' },
    //   body: opportunityTypeBody,
    // },
    // { field: `probability`, header: 'Probability %', style: { textAlign: 'center' }, body: probabilityBody },
    // { field: `amount`, header: 'Amount', style: { textAlign: 'center' }, body: amountBody },
    // {
    //   field: 'expectedCloseDate',
    //   header: 'Exp Close Date',
    //   style: { textAlign: 'center' },
    //   body: expectedCloseDateBody,
    // },
    // { field: `userName`, header: 'Created By', style: { textAlign: 'center' }, body: createdByBody },
    // { field: 'creationDate', header: 'Creation Date', style: { textAlign: 'center' }, body: creationDateBody },
  ]

  return (
    <>
      {isLoading && <Loader />}
      <CustomPrimeTable
        data={prospects.data}
        columns={columns}
        defaultSortMeta={sortMeta()}
        onPage={onPageChange}
        onSort={onSortChange}
        onFilter={onFilterChange}
        query={prospects.query}
        findHidden
        addHidden
        showActions={false}
      />
    </>
  )
}
